export enum IconColorSet {
  gray = "default",
  red = "red",
  orange = "orange",
  yellow = "yellow",
  green = "green",
  mint = "mint",
  blue = "blue",
  grayishBlue = "grayish blue",
  purple = "purple",
  pink = "pink",
}
